module.exports = __webpack_public_path__ + "static/assets/0561e0b45ae23b46a901b25549db50cc.png";